import setContext from './set-context';

export default {
  ...setContext,
};
